import { Slide, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { AuthProvider } from "@features/auth";
import { RegisterProvider } from "@features/register";
import type { ReactNode } from "react";
import { AdditionRequestProvider } from "@features/additions";
import * as RadixTooltip from "@radix-ui/react-tooltip";
import AlertCircleIcon from "./assets/icons/lucide/AlertCircleIcon";
import CheckCircle2Icon from "./assets/icons/lucide/CheckCircle2Icon";

interface IAppProvider {
  children: ReactNode;
}

export const AppProvider = ({ children }: IAppProvider) => {
  return (
    <RadixTooltip.Provider delayDuration={200} skipDelayDuration={500}>
      <RegisterProvider>
        <AuthProvider>
          <AdditionRequestProvider>
            {children}
          </AdditionRequestProvider>
          <ToastContainer
              position="top-right"
              autoClose={4000}
              hideProgressBar={false}
              closeButton={false}
              newestOnTop
              closeOnClick
              pauseOnFocusLoss
              pauseOnHover
              draggable={false}
              theme="light"
              transition={Slide}
              limit={4}
              icon={({ type }) => {
                // Status Tripartite (DESIGN.md): cor + ícone + label.
                // Ícone herda currentColor da variante via CSS.
                if (type === "success") return <CheckCircle2Icon width={20} height={20} />;
                if (type === "info") return <AlertCircleIcon width={20} height={20} />;
                if (type === "warning") return <AlertCircleIcon width={20} height={20} />;
                if (type === "error") return <AlertCircleIcon width={20} height={20} />;
                return null;
              }}
            />
        </AuthProvider>
      </RegisterProvider>
    </RadixTooltip.Provider>
  );
};
